import { render, staticRenderFns } from "./adminsee.vue?vue&type=template&id=fd900280&scoped=true&"
import script from "./adminsee.vue?vue&type=script&lang=js&"
export * from "./adminsee.vue?vue&type=script&lang=js&"
import style0 from "./adminsee.vue?vue&type=style&index=0&id=fd900280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd900280",
  null
  
)

export default component.exports